<template>
  <div v-if="loading" class="py-5 d-flex justify-content-center loading-container">
    <span class="me-2 text-white">Please Wait...</span>
    <div class="spinner-border" role="status"></div>
  </div>
  <BContainer v-else fluid :class="[subscriptionType]">
    <b-row class="d-flex align-items-stretch grid gap-0 row-gap-1">
      <BCol  lg="4"
      xl="4" class="d-flex">
        <UserProfile />
      </BCol>
      <BCol
        lg="4"
        xl="4"
        class="d-flex"
        v-if="
          !isPortfolioEmpty
        "
      >
        <PortfolioList />
      </BCol>
      <BCol
        lg="4"
        xl="4"
        class="d-flex"
        v-if="
          !isPortfolioEmpty
        "
      >
        <AssetAllocation />
      </BCol>
      <BCol
        lg="8"
        xl="8"
        class="d-flex"
        v-if="showEmptyPortfolioView"
      >
        <subPrp />
      </BCol>
    </b-row>
    <b-row
      class="d-flex align-items-stretch grid gap-0 row-gap-1"
      v-if="showEmptyPortfolioView"
    >
      <b-col cols="12" lg="8" class="align-items-stretch">
        <b-row class="d-flex align-items-stretch">
          <b-col lg="6" xl="6" class="d-flex d-none d-lg-block" v-if="shouldHidePrimeRecommendations">
            <PrimeRecommendations />
          </b-col>
          <b-col lg="6" xl="6" class="d-flex d-none d-lg-block" v-if="!shouldHidePrimeRecommendations">
            <WatchList :showSingleTab="0" />
          </b-col>
          <b-col lg="6" xl="6" class="d-flex d-none d-lg-block" v-if="shouldHidePrimeRecommendations">
            <WatchList />
          </b-col>
          <b-col lg="6" xl="6" class="d-flex d-none d-lg-block" v-if="!shouldHidePrimeRecommendations">
            <WatchList :showSingleTab="1" />
          </b-col>
          <b-col cols="12" class="d-lg-none" v-if="!shouldHidePrimeRecommendations">
            <WatchList :showSingleTab="0" />
          </b-col>
          <b-col cols="12" class="d-lg-none" v-if="shouldHidePrimeRecommendations">
            <WatchList />
          </b-col>
          <b-col cols="12" class="d-lg-none">
            <ResearchReports />
          </b-col>
          <b-col cols="12" class="d-lg-none" v-if="!shouldHidePrimeRecommendations">
            <WatchList :showSingleTab="1" />
          </b-col>
          <b-col lg="6" xl="6" class="d-lg-none" v-if="shouldHidePrimeRecommendations">
            <PrimeRecommendations />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" lg="4" class="align-items-stretch d-flex flex-column">
        <b-row class="d-flex align-items-stretch flex-column flex-grow-1">

          <BCol cols="12">
            <StockMarket />
          </BCol>
          <BCol cols="12" class="d-none d-lg-block flex-grow-1 d-flex">
            <ResearchReports />
          </BCol>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="d-flex align-items-stretch grid gap-0 row-gap-1" v-if="isPortfolioEmpty && planType === 'Active'">
      <b-col cols="12" lg="8" class="d-flex align-items-stretch">
        <BCol lg="12" xl="12" cols="12" class="d-flex">
          <PrpExpired />
        </BCol>
      </b-col>
    </b-row>
    <b-row
      class="d-flex align-items-stretch grid gap-0 row-gap-1"
      v-if="!isPortfolioEmpty"
    >
      <b-col cols="12" lg="8" class="align-items-stretch">
        <b-row class="d-flex align-items-stretch">
          <b-col cols="12" class="d-flex">
            <PRPGraph />
          </b-col>
          <b-col lg="6" xl="6" class="d-flex d-none d-lg-block" v-if="shouldHidePrimeRecommendations">
            <PrimeRecommendations />
          </b-col>
          <b-col lg="6" xl="6" class="d-flex d-none d-lg-block" v-if="!shouldHidePrimeRecommendations">
            <WatchList :showSingleTab="0" />
          </b-col>
          <b-col lg="6" xl="6" class="d-flex d-none d-lg-block" v-if="shouldHidePrimeRecommendations">
            <WatchList />
          </b-col>
          <b-col lg="6" xl="6" class="d-flex d-none d-lg-block" v-if="!shouldHidePrimeRecommendations">
            <WatchList :showSingleTab="1" />
          </b-col>
          <b-col cols="12" class="d-lg-none" v-if="!shouldHidePrimeRecommendations">
            <WatchList :showSingleTab="0" />
          </b-col>
          <b-col cols="12" class="d-lg-none" v-if="shouldHidePrimeRecommendations">
            <WatchList />
          </b-col>
          <b-col cols="12" class="d-lg-none" v-if="!shouldHidePrimeRecommendations">
            <WatchList :showSingleTab="1" />
          </b-col>
          <b-col lg="6" xl="6" class="d-lg-none" v-if="shouldHidePrimeRecommendations">
            <PrimeRecommendations />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" lg="4" class="align-items-stretch d-flex flex-column">
        <BCol cols="12" class="d-none d-lg-block">
          <StockMarket />
        </BCol>
        <BCol cols="12" class="d-none d-lg-block flex-grow-1 d-flex">
          <ResearchReports />
        </BCol>
        <BCol cols="12" class="d-lg-none">
          <StockMarket />
        </BCol>
        <BCol cols="12" class="d-lg-none">
          <ResearchReports />
        </BCol>
      </b-col>
    </b-row>
  </BContainer>
</template>

<script>
import PortfolioList from "./components/portfolio.vue";
import AssetAllocation from "./components/asset-allocation.vue";
import PRPGraph from "./components/prp-graph.vue";
import ResearchReports from "./components/research-reports.vue";
import WatchList from "./components/watch-list.vue";
import PrimeRecommendations from "./components/prime-recommendations.vue";
import UserProfile from "./components/user-profile.vue";
import StockMarket from "./components/stock-market.vue";
import PrpExpired from "./components/prp-expired.vue";
import subPrp from "./components/subprp.vue";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    PRPGraph,
    PortfolioList,
    AssetAllocation,
    PrimeRecommendations,
    WatchList,
    ResearchReports,
    UserProfile,
    StockMarket,
    PrpExpired,
    subPrp,
  },
  async created() {
    try {
      await this.$store.dispatch("fetchData");
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.loading = false;
    }
  },
  computed: {
    ...mapGetters([
      "myPortfolio",
      "subscriptionType",
      "planType",
      "userProfile",
      "isPortfolioEmpty",
    ]),
    showEmptyPortfolioView() {
      const eligiblePlans = [
        "Active",
        "Prime-registered",
        "Prime Essentials",
        "Prime Growth",
        "Prime Trial",
        "Trial Expired",
        "Subscription expired",
        "Trial User",
      ];
      return (
        this.isPortfolioEmpty &&
        (!this.planType || eligiblePlans.includes(this.planType))
      );
    },
    shouldHidePrimeRecommendations() {
      if (this.planType != "Active") {
        return false;
      }
      const userRole = this.userProfile?.user_role;
      return userRole === "prime_user" || userRole === "prime_lead" || userRole === "prime_client" || userRole === "administrator";
    },
  },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      loading: true,
    };
  },
  mounted() {
    this.checkIsMobile = this.debounce(this.checkIsMobile, 100);
    window.addEventListener("resize", this.checkIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkIsMobile);
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    },
  },
};
</script>

<style>
.loading-container {
  min-height: 100vh;
  font-size: 18px;
  font-weight: 500;
}

.spinner-border {
  width: 2rem;
  height: 2rem;
}

.row {
  --bs-gutter-x: 0.38rem !important;
  margin-top: 3px !important;
}

.align-items-stretch {
  align-items: stretch;
}

.card {
  margin-bottom: 0.2rem !important;
  border: unset !important;
}

.sub-expired .blur_section {
  filter: blur(8px);
  pointer-events: none;
}

.recommendations-expand {
  flex-grow: 1;
}
</style>
